// Campo de formulario controlado (port de field). Soporta text/number/textarea/
// select, con label, requerido, hint y mensaje de error.
export interface Opcion {
  value: string;
  label: string;
}

interface FieldProps {
  name: string;
  label: string;
  value: string;
  onChange: (v: string) => void;
  type?: 'text' | 'number' | 'password' | 'textarea' | 'select';
  required?: boolean;
  placeholder?: string;
  hint?: string;
  options?: Opcion[];
  invalid?: boolean;
  errMsg?: string;
  min?: number | string;
}

export function Field({
  name, label, value, onChange, type = 'text', required, placeholder, hint, options, invalid, errMsg = 'Este campo es obligatorio', min,
}: FieldProps) {
  const id = 'f_' + name;
  return (
    <div className={`field${invalid ? ' invalid' : ''}`}>
      <label htmlFor={id}>{label}{required ? ' *' : ''}</label>
      {type === 'textarea' ? (
        <textarea id={id} name={name} className="control" required={required} placeholder={placeholder}
          value={value} onChange={(e) => onChange(e.target.value)} />
      ) : type === 'select' ? (
        <select id={id} name={name} className="control" required={required}
          value={value} onChange={(e) => onChange(e.target.value)}>
          {(options ?? []).map((o) => <option key={o.value} value={o.value}>{o.label}</option>)}
        </select>
      ) : (
        <input id={id} name={name} type={type} className="control" required={required} placeholder={placeholder}
          min={min} value={value} onChange={(e) => onChange(e.target.value)} />
      )}
      {hint ? <div className="hint">{hint}</div> : null}
      <div className="err">{errMsg}</div>
    </div>
  );
}
